import lspUtilsService from 'utils/lsp-utils-service';
import { toggleSubmenu, closeAllSideMenuItems } from 'auth/actions/session.actions';
import template from './menu-items.html';

const mapStateToThis = ({ session, documents, config }) => {
  const { sidemenu, locale, adminId } = session;
  const { newLabel } = documents;
  const { licensingServicesLinkHoverText } = config;

  return {
    menuItems: sidemenu,
    newLabel,
    locale,
    adminId,
    licensingServicesLinkHoverText,
  };
};

const mapDispatchToThis = {
  toggleSubmenu,
  closeAllSideMenuItems,
};

@Inject('$ngRedux', 'Responsive', '$document', '$window')
class SideMenuItemsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.$window.addEventListener('resize', this.closeAllSideMenuItems);
  }

  $onDestroy() {
    this.$window.removeEventListener('resize', this.closeAllSideMenuItems);
    this.unsubscribe();
  }

  handleItemClick(item) {
    const element = this.$document[0].querySelector('body');
    const hasMiniBar = angular.element(element).hasClass('mini-navbar');

    if (this.Responsive.isPhone || this.Responsive.isTablet) {
      if (!hasMiniBar) angular.element(element).addClass('mini-navbar');
    }

    if (hasMiniBar) this.toggleSubmenu(item);
  }

  redirectToLSP() {
    lspUtilsService.redirectToLSP('MainMenu', this.adminId);
  }
}

class SideMenuItemsComponent {
  constructor() {
    this.controller = SideMenuItemsController;
    this.template = template;
    return this;
  }
}

export default SideMenuItemsComponent;



// WEBPACK FOOTER //
// ./src/modules/app/components/side-menu/components/menu-items/menu-items.js